export const SINGLE_LOCATION_FETCH_REQUEST = 'single-location-fetch-request';
export const SINGLE_LOCATION_FETCH_SUCCESS = 'single-location-fetch-success';
export const SINGLE_LOCATION_FETCH_FAILURE = 'single-location-fetch-failure';